import {ComponentType} from 'react';
import React, {useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {messageBoxSuccess} from '@deviceinsight/ng-ui-components';
import {withConfirm, Button, ConfirmProps} from '@deviceinsight/ng-ui-basic-components';
import {deleteJob} from '../../../api/updateJobsApi';
type DeleteProps = {
	assetGroupId: number;
	jobId: string;
};
type Props = ConfirmProps & DeleteProps & RouteComponentProps;
const deleteModalTitle = {
	id: 'updatejobs.details.deleteModalTitle',
	defaultValue: 'Delete firmware update'
};
const deleteModalBody = {
	id: 'updatejobs.details.deleteModalBody',
	defaultValue: 'Do you really want to delete the currently scheduled firmware update?'
};

const JobDeleteButtonAndModal = ({assetGroupId, jobId, confirm, history: {push}}: Props) => {
	const [loading, setLoading] = useState<boolean>(false);

	const onSuccessfulDelete = () => {
		messageBoxSuccess(<Trans i18nKey="updatejobs.create.createSuccess">The job was successfully deleted</Trans>);
		push(`/assetgroups/${assetGroupId}/updatejobs`);
	};

	const confirmDelete = () => {
		confirm(deleteModalTitle, deleteModalBody).then(() => {
			setLoading(true);
			deleteJob(assetGroupId, jobId)
				.then(onSuccessfulDelete)
				.catch(() => setLoading(false));
		});
	};

	return (
		<Button danger onClick={confirmDelete} disabled={loading}>
			<Trans i18nKey="updatejobs.details.delete">Delete</Trans>
		</Button>
	);
};

export default withConfirm(withRouter(JobDeleteButtonAndModal)) as ComponentType<DeleteProps>;
